import styled from 'styled-components'
import {
    svgStroke, flashKeyframes,
    belowTablet, belowPhone, fromDesktop, fromPhone
} from 'utilities/styled'
import { Grid } from 'components/grid'
import { CaptionSmall } from 'components/typography/caption'
import { Columns } from 'components/flex'
import Link from 'components/link'

export const SlimDocument = styled(Grid)`
    position: relative;

    grid-template-columns: 1fr;
    grid-column: unset;
    column-gap: inherit;
    align-items: center;

    min-height: 72px;
    padding-block: 16px;

    &::after {
        content: "";
        position: absolute;
        top: 0;
        inset-inline: 0;

        height: 1px;
        background: var(--huma-color-border-default);

        ${fromDesktop`
            inset-inline: 48px 0;
        `}
    }

    ${belowTablet`
        .has-selected :nth-child(1 of &) {
            padding-block-start: 0;

            &::after {
                display: none;
            }
        }
    `}

    ${belowPhone`
        grid-template-columns:
            [bulk] 24px
            [name editable1 editable2] minmax(0, 1fr)
            [actions] 40px;
        grid-auto-rows: auto;
        row-gap: 4px;
    `}

    &.signature {
        ${fromPhone`
            grid-template-rows: minmax(0, 1fr) 24px;
            row-gap: 4px;
        `}
    }

    &.flash {
        animation: ${flashKeyframes} 2s ease-in-out;
    }
`

export const NameCell = styled(Columns)`
    flex-direction: column;
    align-items: flex-start;
    grid-area: unset;

    min-width: 0;
    max-width: 100%;

    svg.feather {
        ${svgStroke()}
    }
`

export const EditLink = styled(Link)`
    display: block;
    max-width: 100%;

    &:is(:hover, :focus-within) {
        text-decoration: none;
    }

    svg {
        margin-inline-end: 24px;
    }
`

export const ConcernsSummary = styled(CaptionSmall)`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &:not(:last-child) {
        margin: 0 0 16px;
    }

    margin-inline-start: 48px;

    ${belowPhone`
        margin-bottom: 8px;
    `}
`